<div *ngIf="!connectWalletVisible" class="relative">
    <div *ngIf="!features || features?.length" class="mb-4 md:mb-6">
        <div class="text-xs md:text-base py-1 px-4 h-8 bg-badge text-sub-text w-fit rounded-full select-none flex-start-center gap-x-2 mb-4">
            <div>Refresh in next block</div>

            <ng-container *ngIf="fetching; else notFetching">
                <span nz-icon nzType="sync" nzSpin></span>
            </ng-container>
            <ng-template #notFetching>
                <div class="text-black">{{leftSeconds}}s</div>
            </ng-template>
        </div>
    </div>

    <div>
        <div *ngIf="!features">
            <nz-skeleton [nzActive]="true"></nz-skeleton>
        </div>
        <div *ngIf="features">
            <div *ngFor="let feature of features; let i = index">
                <div>
                    <!-- 根据 feature.id 渲染不同内容 -->
                    <ng-container [ngSwitch]="feature.id">
                        <!-- ENS -->
                        <div *ngSwitchCase="FeatureType.ENS">
                            <div class="flex-start-center gap-1.5 flex-wrap mb-2.5">
                                <div class="default-tag">{{ FeatureNameMap[feature.id] }}</div>
                                <div *ngIf="feature.value?.ens_holdings?.length" class="other-tag">{{ feature.value.ens_holdings.length }} holdings</div>
                            </div>

                            <div class="space-y-2.5">
                                <div *ngFor="let event of (expandedFeature.has(feature) ? feature.events.data : feature.events.data.slice(0, 3))">
                                    <div class="flex flex-col md:flex-row md:justify-between md:items-center gap-y-1 md:gap-x-2">
                                        <div class="flex-start-center gap-x-2">
                                            <div class="w-fit text-base">{{event.name}}</div>
                                            <div
                                                class="bg-opacity-25 text-xs h-5 leading-5 px-2 w-fit rounded capitalize"
                                                [ngClass]="{
                                                    'text-[#FF8811] bg-[#FF8811] bg-opacity-15': event.action_type !== 'buy' && event.action_type !== 'sell',
                                                    'text-[#2DD36A] bg-[#2DD36A] bg-opacity-15': event.action_type === 'buy',
                                                    'text-[#FF462A] bg-[#FF462A] bg-opacity-15': event.action_type === 'sell'
                                                }"
                                            >
                                                {{ (event.action_type || 'Action')?.split('_').join(' ') | titlecase }}
                                            </div>
                                        </div>
                                        <div class="time">{{ getTime(event.block_timestamp) }}</div>
                                    </div>
                                </div>

                                <ng-container *ngTemplateOutlet="expandTemplate; context: { $implicit: feature }"></ng-container>
                            </div>
                        </div>

                        <!-- OPENSEA -->
                        <div *ngSwitchCase="FeatureType.OPENSEA">
                            <div class="flex-start-center gap-1.5 flex-wrap mb-2.5">
                                <div class="default-tag">{{ FeatureNameMap[feature.id] }}</div>
                                <div class="other-tag">{{ feature.value?.opensea_order_count }} trades</div>
                                <div class="other-tag">${{ feature.value?.volume_usd | number: '1.2-2' }} volume</div>
                            </div>
                            <div class="space-y-2.5">
                                <div
                                    class="flex flex-col md:flex-row md:justify-between md:items-center gap-y-1 md:gap-x-2"
                                    *ngFor="let event of (expandedFeature.has(feature) ? feature.events.data : feature.events.data.slice(0, 3))"
                                >
                                    <div class="flex-start-center gap-x-2">
                                        <img
                                            nz-image
                                            [nzSrc]="tokenImage(ChainEnum.ETHEREUM,event.items[0]?.token_address, event.items[0]?.token_id)"
                                            nzFallback="/assets/imgs/empty-token.png"
                                            [nzDisablePreview]="true"
                                            alt=""
                                            class="w-8 h-8"
                                        />
                                        <div>
                                            <div class="flex-start-center gap-x-1.5">
                                                <div class="font-semibold text-[#2DD36A]">${{ formatNumber(event.volume_usd || 0, 2) }}</div>

                                                <div
                                                    class="bg-opacity-25 text-xs h-5 leading-5 px-2 w-fit rounded capitalize"
                                                    [ngClass]="{
                                                        'text-[#FF8811] bg-[#FF8811] bg-opacity-15': event.action_type !== 'buy' && event.action_type !== 'sell',
                                                        'text-[#2DD36A] bg-[#2DD36A] bg-opacity-15': event.action_type === 'buy',
                                                        'text-[#FF462A] bg-[#FF462A] bg-opacity-15': event.action_type === 'sell'
                                                    }"
                                                >
                                                    {{ event.transaction_type || "Action" }}
                                                </div>
                                            </div>
                                            <div class="mt-1 text-xs flex-start-center">
                                                <div>{{ event.items?.[0]?.token_symbol }}</div>
                                                <div>#{{ event.items?.[0]?.identifier }}</div>
                                                <div class="pl-2 text-[#999]">({{ event.items?.[0]?.token_name }})</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="time">{{ getTime(event.block_timestamp) }}</div>
                                </div>

                                <ng-container *ngTemplateOutlet="expandTemplate; context: { $implicit: feature }"></ng-container>
                            </div>
                        </div>

                        <!-- UNISWAP_V3_TRADING -->
                        <div *ngSwitchCase="FeatureType.UNISWAP_V3_TRADING">
                            <div class="flex-start-center gap-1.5 flex-wrap mb-2.5">
                                <div class="default-tag">{{ FeatureNameMap[feature.id] }}</div>
                                <div class="other-tag">{{ feature.value?.trade_count }} trades</div>
                            </div>

                            <div class="space-y-2.5">
                                <div *ngFor="let event of (expandedFeature.has(feature) ? feature.events.data : feature.events.data.slice(0, 3))">
                                    <div class="flex flex-col md:flex-row md:justify-between md:items-center gap-y-1 md:gap-x-2">
                                        <div class="flex-start-center flex-wrap gap-x-2 gap-y-1">
                                            <img
                                                [src]="event.token0_icon_url || '/assets/imgs/empty-token.png'"
                                                alt=""
                                                class="w-[18px] h-[18px] rounded-full"
                                            />
                                            <div>{{ event.token0_symbol }}</div>
                                            <div class="text-[#2DD36A] font-semibold">{{ formatNumber(event.amount0) }}</div>
                                            <nz-divider class="!mx-0 hidden md:block" [nzType]="'vertical'"></nz-divider>
                                            <img
                                                [src]="event.token1_icon_url || '/assets/imgs/empty-token.png'"
                                                alt=""
                                                class="w-[18px] h-[18px] rounded-full"
                                            />
                                            <div>{{ event.token1_symbol }}</div>
                                            <div class="text-[#2DD36A] font-semibold">{{ formatNumber(event.amount1) }}</div>
                                            <nz-divider class="!mx-0 hidden md:block" [nzType]="'vertical'"></nz-divider>
                                            <div
                                                class="bg-opacity-25 text-xs h-5 leading-5 px-2 w-fit rounded capitalize"
                                                [ngClass]="{
                                                    'text-[#FF8811] bg-[#FF8811] bg-opacity-15': event.action_type !== 'buy' && event.action_type !== 'sell',
                                                    'text-[#2DD36A] bg-[#2DD36A] bg-opacity-15': event.action_type === 'buy',
                                                    'text-[#FF462A] bg-[#FF462A] bg-opacity-15': event.action_type === 'sell'
                                                }"
                                            >
                                                {{ (event.action_type || 'Action')?.split('_').join(' ') | titlecase }}
                                            </div>
                                        </div>
                                        <div class="time">{{ getTime(event.block_timestamp) }}</div>
                                    </div>
                                </div>
                                <ng-container *ngTemplateOutlet="expandTemplate; context: { $implicit: feature }"></ng-container>
                            </div>
                        </div>

                        <!-- UNISWAP_V3_LIQUIDITY -->
                        <div *ngSwitchCase="FeatureType.UNISWAP_V3_LIQUIDITY">
                            <div class="flex-start-center gap-1.5 flex-wrap mb-2.5">
                                <div class="default-tag">{{ FeatureNameMap[feature.id] }}</div>
                                <div class="other-tag">
                                    Added liquidity to {{ feature.value.pool_count }} {{ feature.value.pool_count === 1 ? 'pool' : 'pools' }}
                                </div>
                                <div class="other-tag">Total value ${{ feature.value.total_value_usd | number: '1.0-2' }}</div>
                            </div>
                            <div class="space-y-2.5">
                                <div *ngFor="let event of (expandedFeature.has(feature) ? feature.events.data : feature.events.data.slice(0, 3))">
                                    <div class="flex flex-col md:flex-row md:justify-between md:items-center gap-y-1 md:gap-x-2">
                                        <div class="flex-start-center gap-x-2.5 gap-y-1 flex-wrap">
                                            <div class="flex-start-center gap-x-1.5">
                                                <img
                                                    src="https://pub-651c5abb9f524ba2b54bbe0d8022acfe.r2.dev/2024/09/bb3a6d291904ed5c76664161a60ddafd.png"
                                                    width="18"
                                                    height="18"
                                                    alt="CEX"
                                                    class="rounded-full"
                                                />
                                                <div>Uniswap</div>
                                            </div>

                                            <nz-divider nzType="vertical" class="!mx-0 hidden md:block"></nz-divider>

                                            <div>{{ event.token0?.token0_symbol }}-{{ event.token1?.token1_symbol }}</div>

                                            <nz-divider nzType="vertical" class="!mx-0 hidden md:block"></nz-divider>

                                            <div class="flex-start-center gap-x-1">
                                                <div class="text-[#2DD36A] font-semibold">
                                                    $ {{ formatNumber( (event.token0?.token0_value_usd || 0) + (event.token1?.token1_value_usd || 0), 2 ) }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="time">{{ getTime(event.block_timestamp) }}</div>
                                    </div>
                                </div>
                                <ng-container *ngTemplateOutlet="expandTemplate; context: { $implicit: feature }"></ng-container>
                            </div>
                        </div>

                        <!-- DEPOSIT_TO_L2 -->
                        <div *ngSwitchCase="FeatureType.DEPOSIT_TO_L2">
                            <div class="flex-start-center gap-1.5 flex-wrap mb-2.5">
                                <div class="default-tag">{{ FeatureNameMap[feature.id] }}</div>
                                <div class="other-tag">
                                    ${{ feature.value.total_value_usd | number: '1.2-2' }} assets to {{ feature.value.chain_list?.length || 0 }} L2s
                                </div>
                            </div>
                            <div class="space-y-2.5">
                                <div
                                    *ngFor="let event of (expandedFeature.has(feature) ? feature.events.data : feature.events.data.slice(0, 3))"
                                    class="flex flex-col md:flex-row md:justify-between md:items-center gap-y-1 md:gap-x-2"
                                >
                                    <div>
                                        <div class="flex-start-center gap-x-2.5 gap-y-1 flex-wrap text-base">
                                            <img
                                                [src]="event.token_icon_url || '/assets/imgs/empty-token.png'"
                                                alt=""
                                                width="18"
                                                height="18"
                                                class="rounded-full"
                                            />

                                            <div>{{ formatNumber(event.value) }}</div>

                                            <nz-divider nzType="vertical" class="!mx-0 hidden md:block"></nz-divider>

                                            <div class="flex-start-center gap-x-1">
                                                <div class="flex-start-center gap-x-1">
                                                    <img src="/assets/imgs/chains/eth-blue.png" class="w-4 h-4 rounded-full" alt="" />
                                                    <span>Ethereum</span>
                                                </div>

                                                <span class="text-[#999] px-2">to</span>

                                                <div class="flex-start-center gap-x-1">
                                                    <img [src]="getChainImg(event.chain_name)" class="w-4 h-4 rounded-full" alt="" />
                                                    <span>{{ event.chain_name | titlecase }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="time">{{ getTime(event.block_timestamp) }}</div>
                                </div>
                                <ng-container *ngTemplateOutlet="expandTemplate; context: { $implicit: feature }"></ng-container>
                            </div>
                        </div>

                        <!-- CONTRACT_DEPLOYER -->
                        <div *ngSwitchCase="FeatureType.CONTRACT_DEPLOYER">
                            <div class="flex-start-center gap-1.5 flex-wrap mb-2.5">
                                <div class="default-tag">{{ FeatureNameMap[feature.id] }}</div>
                                <div class="other-tag">Deployed {{ feature.value.deployed_countract_count }} contracts</div>
                            </div>
                            <div class="space-y-2.5">
                                <div *ngFor="let event of (expandedFeature.has(feature) ? feature.events.data : feature.events.data.slice(0, 3))">
                                    <div class="flex flex-col md:flex-row md:justify-between md:items-center gap-y-1 md:gap-x-2">
                                        <div class="flex-start-center gap-x-2 flex-wrap">
                                            <div class="w-fit text-[#999] text-base">Contract:</div>
                                            <div class="break-all">{{ event.contract_address | address}}</div>
                                        </div>
                                        <div class="time">{{ getTime(event.block_timestamp) }}</div>
                                    </div>
                                </div>
                                <ng-container *ngTemplateOutlet="expandTemplate; context: { $implicit: feature }"></ng-container>
                            </div>
                        </div>

                        <!-- TRANSFER_MORE_THAN_100ETH -->
                        <div *ngSwitchCase="FeatureType.TRANSFER_MORE_THAN_100ETH">
                            <div class="flex-start-center gap-1.5 flex-wrap mb-2.5">
                                <div class="default-tag">{{ FeatureNameMap[feature.id] }}</div>
                            </div>
                            <div *ngFor="let event of (expandedFeature.has(feature) ? feature.events.data : feature.events.data.slice(0, 3))">
                                <div class="flex flex-col md:flex-row md:justify-between md:items-center gap-y-1 md:gap-x-2">
                                    <div class="flex items-center gap-x-2">
                                        <img src="/images/eth-blue.png" class="object-contain" width="18" height="18" alt="ETH" />
                                        <span>{{ event.amount }} ETH</span>
                                    </div>
                                    <div class="time">To: {{ event.destination_address }}</div>
                                    <div class="time">{{ getTime(event.block_timestamp) }}</div>
                                </div>
                            </div>
                            <ng-container *ngTemplateOutlet="expandTemplate; context: { $implicit: feature }"></ng-container>
                        </div>

                        <!-- MULTI_SIG_OWNER -->
                        <div *ngSwitchCase="FeatureType.MULTI_SIG_OWNER">
                            <div class="flex-start-center gap-1.5 flex-wrap mb-2.5">
                                <div class="default-tag">{{ FeatureNameMap[feature.id] }}</div>
                            </div>
                            <div *ngFor="let event of (expandedFeature.has(feature) ? feature.events.data : feature.events.data.slice(0, 3))">
                                <div class="flex flex-col md:flex-row md:justify-between md:items-center gap-y-1 md:gap-x-2">
                                    <div class="break-all">{{ event.owner_address }}</div>
                                    <div class="time">{{ getTime(event.block_timestamp) }}</div>
                                </div>
                            </div>
                            <ng-container *ngTemplateOutlet="expandTemplate; context: { $implicit: feature }"></ng-container>
                        </div>

                        <!-- GITCOIN_DONATION -->
                        <div *ngSwitchCase="FeatureType.GITCOIN_DONATION">
                            <div class="flex-start-center gap-1.5 flex-wrap mb-2.5">
                                <div class="default-tag">{{ FeatureNameMap[feature.id] }}</div>
                            </div>
                            <div *ngFor="let event of (expandedFeature.has(feature) ? feature.events.data : feature.events.data.slice(0, 3))">
                                <div class="flex flex-col md:flex-row md:justify-between md:items-center gap-y-1 md:gap-x-2">
                                    <div class="flex-start-center gap-x-2.5 flex-wrap">
                                        <div class="text-[#999]">To:</div>
                                        <div class="break-all">{{ event.recipient_address }}</div>
                                        <img src="/images/eth-blue.png" width="18" height="18" alt="" />
                                        <div>{{ event.amount | number }} ETH</div>
                                    </div>
                                    <div class="time">{{ getTime(event.block_timestamp) }}</div>
                                </div>
                            </div>
                            <ng-container *ngTemplateOutlet="expandTemplate; context: { $implicit: feature }"></ng-container>
                        </div>
                    </ng-container>
                </div>

                <div *ngIf="i !== features.length - 1" class="divider w-full"></div>
            </div>

            <!-- No Data -->
            <div *ngIf="features && !features.length" class="w-32 mx-auto text-center text-[#b5b5b5]">
                <img class="mx-auto w-32" src="/assets/imgs/no-data/no-data.png" alt="No Data" />
                <div>No Traits</div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="connectWalletVisible">
    <!-- TG Connect Wallet -->
    <div class="text-center pb-10 text-[#b5b5b5]">
        <img class="mt-5 mx-auto w-32" src="/assets/imgs/no-data/no-data.png" alt="No Data" />
        <div>Please connect your wallet first.</div>
        <button nz-button nzType="primary" class="mt-4 !h-[34px] !w-[137px]" nzSize="small" (click)="commonService.showLogInModal('Connect New Wallet')">
            <span class="colorful-text">Connect Wallet</span>
        </button>
    </div>
</div>

<ng-template #expandTemplate let-feature>
    <button *ngIf="feature.events.data.length > 3" nz-button class="icon-btn !w-5 !h-5 !text-sub-text" (click)="toggleExpand(feature)">
        <i nz-icon [nzType]="expandedFeature.has(feature) ? 'up' : 'down'" class="!text-xs" nzTheme="outline"></i>
    </button>
</ng-template>
